import React from 'react';
import Revelr from 'configs';
import utils from 'utils';
import { BudgetFlexibility, EventFormats, FoodDrinkNeeds, OutdoorSpacePreferences } from 'lists';
import DetailLine from 'components/leads/detailLine';
import LocationsField from 'components/events/LocationsField';

const VENDOR_TYPES = [
    'Venue',
    'Caterer',
    'Planner',
    'Photographer',
    'Florist',
    'Other',
];

class EventDetails extends React.Component {
    showFoodDrinkBudget() {
        return this.props.event.food_drink === 'dropoff' ||
            (this.props.event.food_drink === 'inhouse' && this.props.event.venue_food_drink === 'only_external');
    }

    render() {
        const event = this.props.event;
        let eventDate = event.date_flexibile ? 'Around ' : 'On ';

        if (event.date) {
            eventDate += event.date.format(Revelr.dateFormat);
        } else if (event.start_date) {
            eventDate += event.start_date.format(Revelr.dateFormat);
        }

        if (event.multiday_event) {
            eventDate += ' (multi-day event)';
        }

        let startDate;
        if (event.startDate) {
            startDate = event.start_date.format(Revelr.dateFormat);
        }

        let endDate;
        if (event.endDate) {
            endDate = event.end_date.format(Revelr.dateFormat);
        }

        let eventPurpose;
        if (event.event_purpose) {
            eventPurpose = event.event_purpose[0].toUpperCase() + event.event_purpose.substr(1);
        }

        let eventFormats;
        if (event.formats) {
            eventFormats = event.formats.map(format => EventFormats[format]);
        }

        const fdBudget = event.food_drink_budget ?
            'Yes, this is my all-in budget for the event' :
            'No, this is just my approximate venue budget';

        return (
            <div className="details">
                <h4>Event Details</h4>
                <div className="details-body">
                    <DetailLine property="Contact Name" detail={event.contact_name} />
                    <DetailLine property="Event Type" detail={event.event_type} />
                    <DetailLine property="Event Purpose" detail={eventPurpose} />
                    <DetailLine property="Company Name" detail={event.company_name} />
                    <DetailLine property="Location" detail={event.location} />
                    {event.location_list.length > 0 && <div className="detail">
                        <div className="property">Location</div>
                        <div>
                            <LocationsField locations={event.location_list} showNeighborhoods={event.venues_selected} />
                        </div>
                    </div>}
                    {event.multiday_event && <div>
                        <DetailLine property="Start Date" detail={startDate} />
                        <DetailLine property="End Date" detail={endDate} />
                    </div>}
                    {!event.multiday_event && <DetailLine property="Date" detail={eventDate} />}
                    <DetailLine property="Alternate Dates" detail={event.alternate_dates} />
                    <DetailLine property="Start Time" detail={event.start_time} />
                    <DetailLine property="End Time" detail={event.end_time} />
                    <DetailLine property="Number of Guests" detail={event.guest_count} />
                    {event.formats && <DetailLine property="Event Format" detail={utils.nl2br(eventFormats.join("\n"))} />}
                    <DetailLine property="Estimated Budget" detail={event.total_budget} />
                    {event.budget_flexibility && <DetailLine property="Budget flexibility" detail={BudgetFlexibility[event.budget_flexibility]} />}
                    {
                        event.food_drink_budget !== null &&
                        this.showFoodDrinkBudget() &&
                        <DetailLine property="Does budget account for food/drinks and venue?" detail={fdBudget} />
                    }
                    {event.outdoor_space && <DetailLine property="Outdoor Space Preference" detail={OutdoorSpacePreferences[event.outdoor_space]} />}
                    {event.food_drink && <DetailLine property="Food and drink needs" detail={FoodDrinkNeeds[event.food_drink]} />}
                    <DetailLine property="Specific Details" detail={utils.nl2br(event.details)} />
                    <DetailLine property="Additional Details" detail={utils.nl2br(event.additional_details)} />
                </div>

                {event.help_with && <div className="looking-for">
                    <h5>I am looking for a</h5>
                    {VENDOR_TYPES.map((type) => {
                        const lowered = type.toLowerCase();
                        if (event.help_with.indexOf(lowered) === -1) {
                            return null;
                        }

                        return (
                            <div key={lowered} className="vendor-icon" data-vendor-type={lowered}>
                                {type}
                            </div>
                        );
                    })}
                </div>}
            </div>
        );
    }
}

EventDetails.propTypes = {
    event: React.PropTypes.object.isRequired,
};

export default EventDetails;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/events/eventDetails.jsx